// ---- Utility functions ----
export function qs(key: string): string | null {
    key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, '\\$&');
    const match = location.search.match(new RegExp('[?&]' + key + '=([^&]+)(&|$)'));
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}


export function makeLine(val: number, dd: any[]): any[] {
    const ss: any[] = [];
    for (let i = 0; i < dd.length; i++) {
        ss.push([dd[i][0], val]);
    }
    return ss;
}
